import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaUser,
    FaIdCard,
    FaPhone,
    FaEnvelope,
    FaHome,
    FaBuilding,
    FaUpload,
    FaFilePdf,
    FaCheckCircle,
    FaArrowLeft,
    FaArrowRight,
    FaInfoCircle,
    FaCalendarCheck,
    FaClipboardList,
    FaPrint,
    FaStore,
    FaUsers,
    FaWarehouse,
    FaCouch,
    FaRulerCombined,
    FaMapMarkedAlt,
    FaClock,
    FaFileAlt,
    FaWifi,
    FaCar,
    FaSnowflake,
    FaDesktop,
    FaChair
} from 'react-icons/fa';

const AjukanPermohonanIPR = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        // Data Pemohon
        namaLengkap: '',
        nik: '',
        noTelp: '',
        email: '',
        alamat: '',
        pekerjaan: '',
        jenisIdentitas: 'ktp',
        nomorIdentitas: '',

        // Data Usaha/Instansi
        namaUsaha: '',
        jenisUsaha: '',
        npwp: '',
        siup: '',

        // Data Ruangan
        jenisRuangan: '',
        lokasiGedung: '',
        nomorRuangan: '',
        lantai: '',
        luasRuangan: '',
        zona: '',
        jangkaWaktu: '1',
        tanggalMulai: '',
        tujuanPenggunaan: '',

        // Fasilitas
        fasilitasTambahan: [],
        kebutuhanKhusus: '',

        // Dokumen
        ktp: null,
        npwpFile: null,
        proposal: null,
        suratPernyataan: null,
        fotoRuangan: null,
        dokumenPendukung: null
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [nomorRegistrasi, setNomorRegistrasi] = useState('');

    const jenisRuanganOptions = [
        { value: 'pertokoan', label: 'Ruang Pertokoan', icon: FaStore, deskripsi: 'Ruko, toko, butik, showroom' },
        { value: 'perkantoran', label: 'Ruang Perkantoran', icon: FaBuilding, deskripsi: 'Kantor, co-working space, agen' },
        { value: 'gudang', label: 'Ruang Gudang', icon: FaWarehouse, deskripsi: 'Gudang, storage, tempat penyimpanan' },
        { value: 'aula', label: 'Aula/Ruang Pertemuan', icon: FaUsers, deskripsi: 'Aula, ballroom, ruang seminar' },
        { value: 'usaha_kecil', label: 'Ruang Usaha Kecil', icon: FaStore, deskripsi: 'Kios, stan, booth, gerai' }
    ];

    const zonaOptions = [
        { value: 'pusat', label: 'Pusat Kota - Jl. Sudirman, Alun-alun, Pecinan' },
        { value: 'menengah', label: 'Zona Menengah - Perumahan, Bisnis Menengah' },
        { value: 'pinggiran', label: 'Zona Pinggiran - Pemukiman, Pinggir Kota' }
    ];

    const lokasiGedungOptions = [
        { value: 'gedung_a', label: 'Gedung A - Komplek Perkantoran Pemkot' },
        { value: 'gedung_b', label: 'Gedung B - Pusat Bisnis Magelang' },
        { value: 'gedung_c', label: 'Gedung C - Pasar Tradisional' },
        { value: 'gedung_d', label: 'Gedung D - Terminal Terpadu' },
        { value: 'ruko_sudirman', label: 'Ruko Sudirman Blok A' },
        { value: 'ruko_alun', label: 'Ruko Alun-alun Selatan' }
    ];

    const fasilitasOptions = [
        { value: 'ac', label: 'AC', icon: FaSnowflake, biaya: 50000 },
        { value: 'internet', label: 'Internet/WiFi', icon: FaWifi, biaya: 30000 },
        { value: 'parkir', label: 'Parkir Khusus', icon: FaCar, biaya: 25000 },
        { value: 'komputer', label: 'Komputer/PC', icon: FaDesktop, biaya: 75000 },
        { value: 'mebel', label: 'Mebel/Mebeler', icon: FaChair, biaya: 50000 },
        { value: 'gudang_tambahan', label: 'Ruang Penyimpanan Tambahan', icon: FaWarehouse, biaya: 35000 },
        { value: 'sound', label: 'Sound System', icon: FaFileAlt, biaya: 45000 },
        { value: 'proyektor', label: 'Proyektor/LCD', icon: FaDesktop, biaya: 40000 }
    ];

    const validateStep = (stepNumber) => {
        const newErrors = {};

        if (stepNumber === 1) {
            if (!formData.namaLengkap) newErrors.namaLengkap = 'Nama lengkap wajib diisi';
            if (!formData.nik && formData.jenisIdentitas === 'ktp') {
                newErrors.nik = 'NIK wajib diisi';
            } else if (formData.nik && formData.nik.length !== 16 && formData.jenisIdentitas === 'ktp') {
                newErrors.nik = 'NIK harus 16 digit';
            }
            if (!formData.noTelp) newErrors.noTelp = 'Nomor telepon wajib diisi';
            if (!formData.alamat) newErrors.alamat = 'Alamat wajib diisi';
            if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
                newErrors.email = 'Format email tidak valid';
            }
            if (!formData.nomorIdentitas) newErrors.nomorIdentitas = 'Nomor identitas wajib diisi';
        }

        if (stepNumber === 2) {
            if (!formData.jenisRuangan) newErrors.jenisRuangan = 'Jenis ruangan wajib dipilih';
            if (!formData.lokasiGedung) newErrors.lokasiGedung = 'Lokasi gedung wajib dipilih';
            if (!formData.luasRuangan) newErrors.luasRuangan = 'Luas ruangan wajib diisi';
            else if (formData.luasRuangan <= 0) newErrors.luasRuangan = 'Luas ruangan tidak valid';
            if (!formData.zona) newErrors.zona = 'Zona lokasi wajib dipilih';
            if (!formData.tanggalMulai) newErrors.tanggalMulai = 'Tanggal mulai sewa wajib diisi';
            if (!formData.tujuanPenggunaan) newErrors.tujuanPenggunaan = 'Tujuan penggunaan wajib diisi';
        }

        if (stepNumber === 3) {
            if (!formData.ktp) newErrors.ktp = 'Foto/Scan KTP wajib diupload';
            if (!formData.proposal) newErrors.proposal = 'Proposal penggunaan wajib diupload';
            if (!formData.suratPernyataan) newErrors.suratPernyataan = 'Surat pernyataan wajib diupload';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            fasilitasTambahan: checked
                ? [...prev.fasilitasTambahan, value]
                : prev.fasilitasTambahan.filter(f => f !== value)
        }));
    };

    const handleFileUpload = (e) => {
        const { name, files } = e.target;
        if (files[0]) {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
            if (errors[name]) {
                setErrors(prev => ({ ...prev, [name]: '' }));
            }
        }
    };

    const nextStep = () => {
        if (validateStep(step)) {
            setStep(prev => prev + 1);
            window.scrollTo(0, 0);
        }
    };

    const prevStep = () => {
        setStep(prev => prev - 1);
        window.scrollTo(0, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateStep(3)) return;

        setIsSubmitting(true);

        // Simulasi pengiriman data ke server
        setTimeout(() => {
            const noReg = 'IPR-' + new Date().getFullYear() + '-' + Math.random().toString(36).substr(2, 8).toUpperCase();
            setNomorRegistrasi(noReg);
            setShowSuccess(true);
            setIsSubmitting(false);
            window.scrollTo(0, 0);
        }, 2000);
    };

    const renderStepIndicator = () => (
        <div className="flex items-center justify-center mb-8">
            {[
                { step: 1, label: 'Data Pemohon', icon: FaUser },
                { step: 2, label: 'Data Ruangan', icon: FaBuilding },
                { step: 3, label: 'Upload Dokumen', icon: FaUpload }
            ].map((item, index) => (
                <React.Fragment key={item.step}>
                    <div className="flex flex-col items-center">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold transition-all duration-300 ${step >= item.step
                                ? 'bg-[#0D9488] text-white shadow-lg'
                                : 'bg-gray-300 text-gray-600'
                            }`}>
                            {step > item.step ? <FaCheckCircle /> : <item.icon />}
                        </div>
                        <span className={`mt-2 text-xs font-medium hidden md:block ${step >= item.step ? 'text-[#0D9488]' : 'text-gray-500'
                            }`}>
                            {item.label}
                        </span>
                    </div>
                    {index < 2 && (
                        <div className={`w-16 md:w-24 h-1 mx-2 transition-all duration-300 ${step > item.step ? 'bg-[#0D9488]' : 'bg-gray-300'
                            }`} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );

    // Tampilan Sukses
    if (showSuccess) {
        return (
            <div className="container mx-auto px-4 py-12">
                <div className="max-w-2xl mx-auto">
                    <div className="card-glass text-center">
                        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                            <FaCheckCircle className="text-6xl text-green-500" />
                        </div>
                        <h2 className="text-3xl font-bold text-[#1E3A8A] mb-4">
                            Pengajuan IPR Berhasil!
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Terima kasih telah mengajukan permohonan Izin Pemakaian Ruangan.
                            Berikut adalah nomor registrasi Anda:
                        </p>

                        <div className="bg-gradient-to-r from-[#1E3A8A] to-[#0D9488] text-white p-6 rounded-lg mb-6">
                            <p className="text-sm opacity-80 mb-2">Nomor Registrasi</p>
                            <p className="text-3xl font-bold font-mono">{nomorRegistrasi}</p>
                            <p className="text-xs opacity-80 mt-2">Simpan nomor ini untuk mengecek status permohonan</p>
                        </div>

                        <div className="text-left bg-gray-50 p-6 rounded-lg mb-6">
                            <h3 className="font-bold text-[#1E3A8A] mb-3 flex items-center">
                                <FaClipboardList className="mr-2" />
                                Informasi Selanjutnya:
                            </h3>
                            <ul className="space-y-3 text-sm text-gray-600">
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Simpan nomor registrasi untuk mengecek status permohonan secara online</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Petugas akan memverifikasi dokumen dalam 1-3 hari kerja</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Tim survey akan menghubungi Anda untuk jadwal peninjauan lokasi ruangan</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Setelah disetujui, Anda akan menerima SKRD untuk pembayaran retribusi</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Serah terima kunci dilakukan setelah pembayaran lunas dan deposit dibayarkan</span>
                                </li>
                            </ul>
                        </div>

                        <div className="bg-blue-50 p-4 rounded-lg mb-6 text-left">
                            <h4 className="font-semibold text-blue-800 mb-2 flex items-center">
                                <FaClock className="mr-2" />
                                Estimasi Waktu Proses:
                            </h4>
                            <div className="grid grid-cols-3 gap-4 text-center text-sm">
                                <div>
                                    <p className="font-bold text-blue-800">1-3 Hari</p>
                                    <p className="text-blue-600">Verifikasi Dokumen</p>
                                </div>
                                <div>
                                    <p className="font-bold text-blue-800">3-5 Hari</p>
                                    <p className="text-blue-600">Survey Lokasi</p>
                                </div>
                                <div>
                                    <p className="font-bold text-blue-800">2-3 Hari</p>
                                    <p className="text-blue-600">Penerbitan SKRD</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col md:flex-row gap-4">
                            <button
                                onClick={() => window.print()}
                                className="flex-1 bg-[#0F172A] text-white px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-colors flex items-center justify-center"
                            >
                                <FaPrint className="mr-2" />
                                Cetak Bukti Pengajuan
                            </button>
                            <Link
                                to="/layanan/retribusi-ipr"
                                className="flex-1 bg-gray-200 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors flex items-center justify-center"
                            >
                                <FaArrowLeft className="mr-2" />
                                Kembali ke IPR
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-2">
                    <FaBuilding className="text-3xl text-[#0D9488]" />
                    <h1 className="text-3xl font-bold text-[#1E3A8A]">
                        Formulir Pengajuan Izin Pemakaian Ruangan (IPR)
                    </h1>
                </div>
                <p className="text-gray-600 ml-12">
                    Lengkapi formulir berikut untuk mengajukan permohonan sewa ruangan aset Pemkot Magelang
                </p>
            </div>

            {/* Step Indicator */}
            {renderStepIndicator()}

            <div className="max-w-4xl mx-auto">
                <div className="card-glass">
                    <form onSubmit={handleSubmit}>
                        {/* Step 1: Data Pemohon */}
                        {step === 1 && (
                            <div className="space-y-6">
                                <div className="flex items-center pb-4 border-b border-gray-200">
                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                        <FaUser className="text-xl text-[#0D9488]" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Data Pemohon</h2>
                                        <p className="text-sm text-gray-500">Data pribadi pemohon sewa ruangan</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nama Lengkap <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="namaLengkap"
                                            value={formData.namaLengkap}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent transition-all ${errors.namaLengkap ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan nama lengkap sesuai KTP"
                                        />
                                        {errors.namaLengkap && (
                                            <p className="text-red-500 text-xs mt-1 flex items-center">
                                                <FaInfoCircle className="mr-1" /> {errors.namaLengkap}
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jenis Identitas <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="jenisIdentitas"
                                            value={formData.jenisIdentitas}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="ktp">KTP</option>
                                            <option value="sim">SIM</option>
                                            <option value="paspor">Paspor</option>
                                        </select>
                                    </div>

                                    {formData.jenisIdentitas === 'ktp' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                NIK <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="nik"
                                                value={formData.nik}
                                                onChange={handleInputChange}
                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.nik ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                    }`}
                                                placeholder="Masukkan 16 digit NIK"
                                                maxLength="16"
                                            />
                                            {errors.nik && (
                                                <p className="text-red-500 text-xs mt-1 flex items-center">
                                                    <FaInfoCircle className="mr-1" /> {errors.nik}
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nomor Identitas <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="nomorIdentitas"
                                            value={formData.nomorIdentitas}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.nomorIdentitas ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan nomor identitas"
                                        />
                                        {errors.nomorIdentitas && (
                                            <p className="text-red-500 text-xs mt-1 flex items-center">
                                                <FaInfoCircle className="mr-1" /> {errors.nomorIdentitas}
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nomor Telepon <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="tel"
                                            name="noTelp"
                                            value={formData.noTelp}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.noTelp ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                }`}
                                            placeholder="Contoh: 08123456789"
                                        />
                                        {errors.noTelp && (
                                            <p className="text-red-500 text-xs mt-1 flex items-center">
                                                <FaInfoCircle className="mr-1" /> {errors.noTelp}
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.email ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                }`}
                                            placeholder="contoh@email.com"
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-xs mt-1 flex items-center">
                                                <FaInfoCircle className="mr-1" /> {errors.email}
                                            </p>
                                        )}
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Alamat Lengkap <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="alamat"
                                            value={formData.alamat}
                                            onChange={handleInputChange}
                                            rows="3"
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.alamat ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan alamat lengkap sesuai KTP"
                                        />
                                        {errors.alamat && (
                                            <p className="text-red-500 text-xs mt-1 flex items-center">
                                                <FaInfoCircle className="mr-1" /> {errors.alamat}
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Pekerjaan
                                        </label>
                                        <input
                                            type="text"
                                            name="pekerjaan"
                                            value={formData.pekerjaan}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            placeholder="Masukkan pekerjaan"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nama Usaha/Instansi
                                        </label>
                                        <input
                                            type="text"
                                            name="namaUsaha"
                                            value={formData.namaUsaha}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            placeholder="Nama usaha atau instansi (jika ada)"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Step 2: Data Ruangan */}
                        {step === 2 && (
                            <div className="space-y-6">
                                <div className="flex items-center pb-4 border-b border-gray-200">
                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                        <FaBuilding className="text-xl text-[#0D9488]" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Data Ruangan yang Dimohon</h2>
                                        <p className="text-sm text-gray-500">Informasi detail ruangan yang akan disewa</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jenis Ruangan <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="jenisRuangan"
                                            value={formData.jenisRuangan}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.jenisRuangan ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        >
                                            <option value="">Pilih Jenis Ruangan</option>
                                            {jenisRuanganOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label} - {opt.deskripsi}</option>
                                            ))}
                                        </select>
                                        {errors.jenisRuangan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.jenisRuangan}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Lokasi Gedung <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="lokasiGedung"
                                            value={formData.lokasiGedung}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.lokasiGedung ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        >
                                            <option value="">Pilih Lokasi Gedung</option>
                                            {lokasiGedungOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                        {errors.lokasiGedung && (
                                            <p className="text-red-500 text-xs mt-1">{errors.lokasiGedung}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nomor Ruangan
                                        </label>
                                        <input
                                            type="text"
                                            name="nomorRuangan"
                                            value={formData.nomorRuangan}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            placeholder="Contoh: R.01 atau A-12"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Lantai
                                        </label>
                                        <select
                                            name="lantai"
                                            value={formData.lantai}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="">Pilih Lantai</option>
                                            <option value="1">Lantai 1</option>
                                            <option value="2">Lantai 2</option>
                                            <option value="3">Lantai 3</option>
                                            <option value="4">Lantai 4</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Luas Ruangan (m²) <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                name="luasRuangan"
                                                value={formData.luasRuangan}
                                                onChange={handleInputChange}
                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.luasRuangan ? 'border-red-500' : 'border-gray-300'
                                                    }`}
                                                placeholder="Masukkan luas ruangan"
                                            />
                                            <span className="absolute right-3 top-2.5 text-gray-400">m²</span>
                                        </div>
                                        {errors.luasRuangan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.luasRuangan}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Zona Lokasi <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="zona"
                                            value={formData.zona}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.zona ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        >
                                            <option value="">Pilih Zona</option>
                                            {zonaOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                        {errors.zona && (
                                            <p className="text-red-500 text-xs mt-1">{errors.zona}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jangka Waktu Sewa
                                        </label>
                                        <select
                                            name="jangkaWaktu"
                                            value={formData.jangkaWaktu}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="1">1 Tahun</option>
                                            <option value="2">2 Tahun</option>
                                            <option value="3">3 Tahun</option>
                                            <option value="5">5 Tahun</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Tanggal Mulai Sewa <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            name="tanggalMulai"
                                            value={formData.tanggalMulai}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tanggalMulai ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />
                                        {errors.tanggalMulai && (
                                            <p className="text-red-500 text-xs mt-1">{errors.tanggalMulai}</p>
                                        )}
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Tujuan Penggunaan Ruangan <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="tujuanPenggunaan"
                                            value={formData.tujuanPenggunaan}
                                            onChange={handleInputChange}
                                            rows="4"
                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tujuanPenggunaan ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Jelaskan secara detail rencana penggunaan ruangan"
                                        />
                                        {errors.tujuanPenggunaan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.tujuanPenggunaan}</p>
                                        )}
                                    </div>

                                    {/* Fasilitas Tambahan */}
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-3">
                                            Fasilitas Tambahan yang Diminta
                                        </label>
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                            {fasilitasOptions.map(fasilitas => (
                                                <label key={fasilitas.value} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
                                                    <input
                                                        type="checkbox"
                                                        value={fasilitas.value}
                                                        checked={formData.fasilitasTambahan.includes(fasilitas.value)}
                                                        onChange={handleCheckboxChange}
                                                        className="mr-2 text-[#0D9488] focus:ring-[#0D9488]"
                                                    />
                                                    <fasilitas.icon className="text-gray-600 mr-2" />
                                                    <div>
                                                        <span className="text-sm font-medium text-gray-700">{fasilitas.label}</span>
                                                        <p className="text-xs text-gray-500">+Rp {fasilitas.biaya.toLocaleString()}/bln</p>
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Kebutuhan Khusus Lainnya
                                        </label>
                                        <textarea
                                            name="kebutuhanKhusus"
                                            value={formData.kebutuhanKhusus}
                                            onChange={handleInputChange}
                                            rows="2"
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            placeholder="Sebutkan jika ada kebutuhan khusus (renovasi, instalasi tambahan, dll)"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Step 3: Upload Dokumen */}
                        {step === 3 && (
                            <div className="space-y-6">
                                <div className="flex items-center pb-4 border-b border-gray-200">
                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                        <FaUpload className="text-xl text-[#0D9488]" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Upload Dokumen Pendukung</h2>
                                        <p className="text-sm text-gray-500">Lengkapi dokumen persyaratan pengajuan IPR</p>
                                    </div>
                                </div>

                                <div className="bg-yellow-50 p-4 rounded-lg mb-4 flex items-start">
                                    <FaInfoCircle className="text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                                    <div>
                                        <p className="text-sm font-semibold text-yellow-800 mb-1">Ketentuan Upload:</p>
                                        <ul className="text-sm text-yellow-700 list-disc list-inside space-y-1">
                                            <li>Format file: PDF, JPG, PNG</li>
                                            <li>Ukuran maksimal 5MB per file</li>
                                            <li>File wajib diupload untuk dokumen bertanda <span className="text-red-500">*</span></li>
                                            <li>Pastikan dokumen terbaca dengan jelas</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    {[
                                        { name: 'ktp', label: 'Foto/Scan KTP', required: true, icon: FaIdCard },
                                        { name: 'npwpFile', label: 'Foto/Scan NPWP (Opsional)', required: false, icon: FaFileAlt },
                                        { name: 'proposal', label: 'Proposal Penggunaan Ruangan', required: true, icon: FaFilePdf },
                                        { name: 'suratPernyataan', label: 'Surat Pernyataan Bermaterai', required: true, icon: FaFilePdf },
                                        { name: 'fotoRuangan', label: 'Foto Ruangan (Jika Ada)', required: false, icon: FaBuilding },
                                        { name: 'dokumenPendukung', label: 'Dokumen Pendukung Lainnya', required: false, icon: FaFileAlt }
                                    ].map((doc) => (
                                        <div key={doc.name} className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:border-[#0D9488] transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center">
                                                    <doc.icon className="text-gray-400 mr-3 text-xl" />
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700">
                                                            {doc.label} {doc.required && <span className="text-red-500">*</span>}
                                                        </label>
                                                        {formData[doc.name] && (
                                                            <p className="text-sm text-green-600 mt-1">
                                                                ✓ {formData[doc.name].name}
                                                            </p>
                                                        )}
                                                        {errors[doc.name] && (
                                                            <p className="text-red-500 text-xs mt-1">{errors[doc.name]}</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                                                    Pilih File
                                                    <input
                                                        type="file"
                                                        name={doc.name}
                                                        onChange={handleFileUpload}
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        className="hidden"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Navigation Buttons */}
                        <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
                            {step > 1 ? (
                                <button
                                    type="button"
                                    onClick={prevStep}
                                    className="flex items-center px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    <FaArrowLeft className="mr-2" />
                                    Sebelumnya
                                </button>
                            ) : (
                                <Link
                                    to="/layanan/retribusi-ipr"
                                    className="flex items-center px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    <FaArrowLeft className="mr-2" />
                                    Kembali
                                </Link>
                            )}

                            {step < 3 ? (
                                <button
                                    type="button"
                                    onClick={nextStep}
                                    className="flex items-center btn-primary"
                                >
                                    Selanjutnya
                                    <FaArrowRight className="ml-2" />
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`flex items-center btn-primary ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                            Mengirim Permohonan...
                                        </>
                                    ) : (
                                        <>
                                            <FaCheckCircle className="mr-2" />
                                            Kirim Permohonan IPR
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                {/* Info Tambahan */}
                <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="card-glass text-center">
                        <FaClock className="text-2xl text-[#0D9488] mx-auto mb-2" />
                        <h4 className="font-semibold text-[#1E3A8A] mb-1">Proses Cepat</h4>
                        <p className="text-sm text-gray-600">Verifikasi 1-3 hari kerja</p>
                    </div>
                    <div className="card-glass text-center">
                        <FaFileAlt className="text-2xl text-[#0D9488] mx-auto mb-2" />
                        <h4 className="font-semibold text-[#1E3A8A] mb-1">Dokumen Aman</h4>
                        <p className="text-sm text-gray-600">Data terenkripsi dan aman</p>
                    </div>
                    <div className="card-glass text-center">
                        <FaPhone className="text-2xl text-[#0D9488] mx-auto mb-2" />
                        <h4 className="font-semibold text-[#1E3A8A] mb-1">Bantuan 24/7</h4>
                        <p className="text-sm text-gray-600">Konsultasi kapan saja</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AjukanPermohonanIPR;